import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const sendToSupplier = createApi(`SendToSupplierSlice`, "POST");

const SendToSupplierSlice = createSlice({
  name: 'SendToSupplierSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendToSupplier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendToSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(sendToSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default SendToSupplierSlice.reducer;
